<!--
 * @Author: liushumin
 * @Date: 2022-05-28 00:04:32
 * @LastEditTime: 2022-09-08 14:10:03
 * @LastEditors: quwandong
-->
<template>
  <div class="content" :style="{ height: height }">
    <div class="map-wrap">
      <!-- 地图 -->
      <div
        class="map-div"
        id="mapDiv"
        ref="mapDiv"
        v-loading="loadingFlag"
      ></div>
      <!-- 环境监测切卡 -->
      <div class="map-top-info">
        <ul class="list">
          <template v-if="deviceFlag == true">
            <li
              class="item cursor"
              v-for="(item, index) in deviceType"
              :class="{ active: currentIndex === index }"
              :key="index"
              @click="handleFilterDevice(index, item)"
            >
              <template>
                <div>
                  <img :src="item.light_img" alt="" />
                </div>
                <span class="name">{{ item.monitor_type_name }} </span>
              </template>
            </li>
          </template>
          <template v-else>
            <li
              class="item cursor"
              v-for="(item, index) in deviceSingle"
              :class="{ active: currentIndex === index }"
              :key="index"
              @click="handleFilterDevice(index, item)"
            >
              <template>
                <div>
                  <img :src="item.light_img" alt="" />
                </div>
                <span class="name">{{ item.monitor_type_name }} </span>
              </template>
            </li>
          </template>
        </ul>
        <div class="show-btn" @click="handleChangeTopInfo">
          <img :src="packImg" class="show_arrow" v-if="packBtn" />
        </div>
        <div class="show-btn" @click="handleChangePackInfo">
          <img :src="packImg" class="show_arrow left_arrow" v-if="showBtn" />
        </div>
      </div>
      <!-- 地块、作业、审核 -->
      <!-- <div
        v-if="showRightInfo"
        class="map-right-info"
        :class="showRightInfo ? 'map-right-info-show' : 'map-right-info-close'"
      >
        <MapRightInfo :landId="landId"></MapRightInfo>
        <div class="close-btn" @click="handleChangeRightInfo">
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div> -->
      <!-- 设备信息 -->
      <div
        v-if="showDeviceInfo"
        class="map-right-info"
        :class="showDeviceInfo ? 'map-right-info-show' : 'map-right-info-close'"
      >
        <MapRightDevice
          @videoChange="getVideoStatus"
          :farmAllData="farmAllData"
          ref="rightDevice"
        ></MapRightDevice>

        <div class="close-btn" @click="handleChangeDeviceInfo">
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div>
    </div>
    <Videos
      :videoDialog.sync="videoDialog2"
      @updatefun="updatefun2"
      @flagVideo="flagVideo"
      ref="Videos"
    ></Videos>
  </div>
</template>

<script>
import bus from "../LandMapNq/js/bus";
import * as maptalks from "maptalks";
import TalksMap from "../LandMapNq/js/initMapTalksAgr";
import MapRightInfo from "./MapRightInfo.vue";
import MapRightDevice from "./MapRightDevice.vue";
import Videos from "../../Videos.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "LandMap",
  props:['SearchName','MasterId','height'],
  data() {
    return {
      TalksMap: new TalksMap(),
      showRightInfo: false, // 是否显示右侧信息
      showDeviceInfo: false, //是否显示右侧设备信息
      curPolygonVal: {}, //点击某块的数据
      currentIndex: 0,
      monitorTypeId: "",
      videoDialog: false,
      videoDialog2: false,
      packBtn: true,
      showBtn: false,
      landId: "",
      deviceCode: "",
      loadingFlag: false,
      deviceSingle: [
        {
          deviceTypeId: "",
          monitor_type_name: "全部设备",
          light_img: require("@/assets/agricultural/nqfont/all_icon.png"),
        },
      ],
      deviceType: [
        {
          deviceTypeId: "",
          monitor_type_name: "全部设备",
          light_img: require("@/assets/agricultural/nqfont/all_icon.png"),
        },
        {
          deviceTypeId: "10",
          monitor_type_name: "环境监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon1.png"),
        },
        {
          deviceTypeId: "20",
          monitor_type_name: "土壤监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon2.png"),
        },
        {
          deviceTypeId: "30",
          monitor_type_name: "长势监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon3.png"),
        },
        {
          deviceTypeId: "40",
          monitor_type_name: "视频监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon4.png"),
        },
      ],
      packImg: require("@/assets/agricultural/nqfont/pack_icon.png"),
      deviceFlag: true,
      landData: [],
      deviceData: [],
      deviceName: "",
      farmAllData: {},
      masterId: "",
    };
  },
  components: {
    MapRightInfo,
    MapRightDevice,
    Videos,
  },
  // props: {
  //   height: {
  //     type: String,
  //     // default: "670px",
  //     default: "100%",
  //   },
  //   height: {
  //     type: String,
  //     // default: "670px",
  //     default: "100%",
  //   },
  // },
  mounted() {
    console.log(this.$store.state.Agricultural);
    this.getMapInit();
  },
  created() {
  },
  watch: {
    'SearchName':{
      handler: function (n) {
        console.log(n);
        this.getMapData()
      },
      
    },
    'MasterId':{
      handler: function (n) {
        console.log(n);
        this.getMapData()
      },
      
    }
  },
  destroyed() {
    this.$bus.$off("changeRightInfo");
  },
  computed:{
    ...mapState("Agricultural", {
      changeSearchName: (state) => state.searchName,
    }),
    showTrajectoryMulti() {
      const { changeSearchName } = this;
      return { changeSearchName };
    },
  },
  methods: {
    // 设备切卡展开收起
    handleChangeTopInfo() {
      this.packBtn = false;
      this.showBtn = true;
      this.deviceFlag = false;
    },
    handleChangePackInfo() {
      this.packBtn = true;
      this.showBtn = false;
      this.deviceFlag = true;
    },
    // 视频放大功能
    getVideoStatus(val) {
      console.log(val);
      this.videoDialog = val;
      this.videoDialog2 = true;
      this.$refs.Videos.fn();
    },
    updatefun2(val) {
      console.log(val);
      this.videoDialog2 = val;
    },
    //初始化地图
    getMapInit() {
      this.TalksMap.init("mapDiv", 17);
      this.allPointLayer = new maptalks.VectorLayer("point").addTo(
        this.TalksMap.map
      );
      this.TalksMap.map.setMinZoom(4);
      this.TalksMap.map.setZoom(17);
      this.getMapData();
    },
    // 获取地图上的数据
    getMapData() {
      this.loadingFlag = true;
      this.mapData = [];
      console.log(this.TalksMap.markerLayer);
      if (this.TalksMap.landLayer || this.TalksMap.markerLayer) {
        this.TalksMap.landLayer.clear();
        this.TalksMap.markerLayer.clear();
      }
      this.$http.nqMonitor
        .monitorDevice({
          type: this.monitorTypeId,
          masterId: this.MasterId,
          searchName: this.SearchName,
        })
        .then((res) => {
          console.log('289',res);
          this.loadingFlag = false;
          if (res.data.length > 0) {
            this.mapData = res.data;
            this.deviceData = res.data;
            let Coordinate;
            var listPosinArr = res.data;
            if (listPosinArr.length > 0) {
              let centroidArr = JSON.parse(listPosinArr[0].centroid);
              if (listPosinArr.length > 0) {
                Coordinate = {
                  x: Number(centroidArr[0]),
                  y: Number(centroidArr[1]),
                };
              }
              this.TalksMap.map.setCenter(Coordinate);
              this.drawPolygon();
            }
          } else {
            this.deviceData = [];
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    //渲染地块
    drawPolygon() {
      console.log('295',this.mapData);
      if (this.mapData && this.mapData.length > 0) {
        if (this.TalksMap.landLayer) {
          this.TalksMap.landLayer.clear();
        }
        console.log(this.mapData);
        for (var i = 0; i < this.mapData.length; i++) {
          let landArr = [];
          if (this.mapData[i].croplandEdge != null) {
            let mapEdge = JSON.parse(this.mapData[i].croplandEdge);
            if (mapEdge[0][0] && mapEdge[0][0][0]) {
              landArr = mapEdge[0];
              let multiPolygon = new maptalks.Polygon(landArr, {
                visible: true,
                editable: true,
                cursor: null,
                shadowBlur: 0,
                shadowColor: "black",
                draggable: false,
                dragShadow: false,
                drawOnAxis: null,
                symbol: {
                  lineColor: "#00999f",
                  lineWidth: 2,
                  polygonFill: "#00999f",
                  polygonOpacity: 0.5,
                },
                properties: this.mapData[i],
              });
              // multiPolygon.on("click", this.landCallBack);

              multiPolygon.addTo(this.TalksMap.landLayer);
            }
          }
        }
        this.setMarker();
      } else {
        this.TalksMap.landLayer.clear();
      }
    },
    //弹窗视频关闭 右侧透明栏视频播放
    flagVideo(val) {
      this.$refs.rightDevice.getVideoUrl();
    },
    //地块信息
    landCallBack(e) {
      // 点击地块清空设备选中颜色
      this.setMarker();
      this.showRightInfo = true;
      this.showDeviceInfo = false;
      this.curPolygonVal = e.target.properties;
      this.landId = e.target.properties.id;
      for (var i = 0; i < this.TalksMap.landLayer._geoList.length; i++) {
        this.TalksMap.landLayer._geoList[i].setSymbol({
          lineColor: "#00999f",
          lineWidth: 2,
          polygonFill: "#00999f",
          polygonOpacity: 0.5,
        });
      }
      e.target.setSymbol({
        polygonFill: "#00999f",
        lineWidth: 2,
        lineColor: "#00999f",
        polygonOpacity: 0.5,
      });
    },
    //地图上设置marker
    setMarker() {
      var this_ = this;
      console.log(this.deviceData);
      if (this.deviceData && this.deviceData.length > 0) {
        var marker;
        if (this.TalksMap.markerLayer) {
          this.TalksMap.markerLayer.clear();
        }
        for (var i = 0; i < this.deviceData.length; i++) {
          let markerList = this.deviceData[i].deviceList;
          console.log(markerList);
          if (markerList.length > 0) {
            for (var j = 0; j < markerList.length; j++) {
              console.log(markerList[j].deviceTypeId);
              console.log(markerList[j].lon);
              console.log(markerList[j].lat);
              let iconUrl = "";
              if (markerList[j].deviceTypeId == 10) {
                iconUrl = require("@/assets/agricultural/nqfont/gray1.png");
                // iconUrl = require("");
              } else if (markerList[j].deviceTypeId == 20) {
                iconUrl = require("@/assets/agricultural/nqfont/gray2.png");
              } else if (markerList[j].deviceTypeId == 40) {
                iconUrl = require("@/assets/agricultural/nqfont/gray3.png");
              } else if (markerList[j].deviceTypeId == 30) {
                iconUrl = require("@/assets/agricultural/nqfont/gray4.png");
              } else {
                iconUrl = "";
              }
              if (iconUrl != "") {
                let poi = [
                  Number(markerList[j].lon),
                  Number(markerList[j].lat),
                ];
                console.log(poi);
                marker = new maptalks.Marker(poi, {
                  symbol: [
                    {
                      markerFile: iconUrl,
                      // markerWidth: '10%',
                      // markerHeight: 65,
                      markerOpacity: 1,
                    },
                  ],
                });
                console.log(this_.TalksMap);
                marker.addTo(this_.TalksMap.markerLayer);
                marker.val = markerList[j];
                marker.on("click", this_.markerClick);
              }
            }
          }
        }
      }
    },
    // 地图上农情设备点击
    markerClick(e) {
      // 点击设备清空地块选中颜色
      for (var i = 0; i < this.TalksMap.landLayer._geoList.length; i++) {
        this.TalksMap.landLayer._geoList[i].setSymbol({
          lineColor: "#00999f",
          lineWidth: 2,
          polygonFill: "#00999f",
          polygonOpacity: 0.5,
        });
      }
      this.targetId = e.target.val.deviceTypeId;
      this.edition = e.target.val.edition;
      let markerPoints = this.TalksMap.markerLayer._geoList;
      let iconLightUrl;
      this.showDeviceInfo = true;
      this.showRightInfo = false;
      let deviceTypeName = "";
      for (var j = 0; j < markerPoints.length; j++) {
        if (this.targetId == 10) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green1.png");
          deviceTypeName = "环境监测";
        } else if (this.targetId == 20) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green2.png");
          deviceTypeName = "土壤监测";
        } else if (this.targetId == 40) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green3.png");
          deviceTypeName = "视频监测";
        } else if (this.targetId == 30) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green4.png");
          deviceTypeName = "长势监测";
        }
        let icons;
        if (markerPoints[j].val.deviceTypeId == 10) {
          icons = require("@/assets/agricultural/nqfont/gray1.png");
        }
        if (markerPoints[j].val.deviceTypeId == 20) {
          icons = require("@/assets/agricultural/nqfont/gray2.png");
        }
        if (markerPoints[j].val.deviceTypeId == 40) {
          icons = require("@/assets/agricultural/nqfont/gray3.png");
        }
        if (markerPoints[j].val.deviceTypeId == 30) {
          icons = require("@/assets/agricultural/nqfont/gray4.png");
        }
        markerPoints[j].setSymbol({
          markerFile: icons,
          // markerWidth: '10%',
          // markerHeight: 65,
          markerOpacity: 1,
        });
      }
      e.target.setSymbol({
        markerFile: iconLightUrl,
        // markerWidth: '10%',
        // markerHeight: 65,
        markerOpacity: 1,
      });
      this.farmAllData = {
        deviceTypeName: deviceTypeName,
        deviceCode: e.target.val.deviceCode,
        deviceTypeId: e.target.val.deviceTypeId,
        edition: e.target.val.edition,
        deviceName: e.target.val.reserveOne,
      };
      sessionStorage.setItem("farmAllData", JSON.stringify(this.farmAllData));
    },
    //环境监测切卡
    handleFilterDevice(index, item) {
      this.currentIndex = index;
      this.monitorTypeId = item.deviceTypeId;
      this.showDeviceInfo = false;
      this.showRightInfo = false;
      this.getMapData();
    },
    // 切换右侧设备弹框
    handleChangeDeviceInfo() {
      this.showDeviceInfo = false;
    },
    // 切换右侧地块信息弹框
    handleChangeRightInfo() {
      this.showRightInfo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  .map-wrap {
    position: relative;
    height: 100%;
    margin-top: 10px;
    overflow: hidden;
    background-color: #f1f3f8;
    .map-div {
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep {
  .maptalks-attribution {
    display: none;
  }
}
.maptalks-zoom {
  display: none;
}
.map-top-info {
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  background-color: rgba($color: #000000, $alpha: 0.8);
  border-radius: 0px 0px 23px 0px;
  .show-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .show_arrow {
      width: 18px;
      height: 18px;
    }
    .left_arrow {
      transform: rotateY(180deg);
    }
  }

  .list {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 44px;
    .item {
      display: flex;
      align-items: center;
      position: relative;
      height: 100%;
      padding: 0 12px;
      color: #fefeff;
      &.cursor {
        cursor: pointer;
      }
      img {
        width: auto;
        height: 42px;
        margin-right: 5px;
      }
      &.active {
        .name {
          position: relative;
          &::after {
          }
        }
      }
      .name {
        display: inline-flex;
        align-items: center;
        height: 38px;
      }
      .icon {
        margin-right: 5px;
      }
      .block {
        display: none;
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .item:nth-child(1) img {
      width: auto;
      height: 32px;
      margin-right: 5px;
    }

    .active {
      background: #018388;
    }

    .item-sel {
      ::v-deep .el-checkbox {
        color: #018388;
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border: solid 1px #018388;
          background-color: transparent;
          &::after {
            width: 4px;
            height: 8px;
            border-color: #018388;
          }
        }
        .el-checkbox__label {
          font-size: 16px;
        }
      }
    }
  }
}
.map-right-info {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100% !important;
  background-color: rgba($color: #000000, $alpha: 0.75);
  transition: 0.3s;
  &.map-right-info-show {
    transform: translateX(0);
  }
  &.map-right-info-close {
    transform: translateX(120%);
  }
  .close-btn {
    position: absolute;
    top: 50%;
    left: -32px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 72px;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.75);
    .el-icon-d-arrow-right {
      color: #fff;
    }
  }
  ::v-deep {
    .el-tabs__header {
      margin-bottom: 0;
      .el-tabs__nav {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        .el-tabs__active-bar {
          height: 0;
        }
        .el-tabs__item {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 9px;
          color: #fff;
          height: 36px;
          &:nth-child(2) {
            padding-left: 9px !important;
          }
          &:not(:last-child) {
            margin-right: 4px;
          }
          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: -1;
            background-color: #018388;
            transform: skew(-20deg);
          }
          &.is-active {
            color: #fff;
            font-weight: normal;
            &::after {
              // background-color: #e29002;
              background-color: #018388;
            }
          }
        }
      }
    }
  }
}
</style>
